import { useState, useEffect } from 'react'
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink } from '@chakra-ui/react'
import { useRouter } from 'next/router'
import Link from 'next/link'
import Head from 'next/head'

import { LayoutProps } from './types'

import Footer from 'components/Footer'
import Navbar from 'components/Navbar'
import Container from 'components/Container'

import * as S from './styles'
import { ChevronRightIcon } from '@chakra-ui/icons'

const convertBreadcrumb = (string: any) => {
  return (
    string
      .replace(/-/g, ' ')
      .replace(/oe/g, 'ö')
      .replace(/ae/g, 'ä')
      .replace(/ue/g, 'ü')
      .charAt(0)
      .toUpperCase() + string.slice(1)
  )
}

export default function Layout({ children, ...props }: LayoutProps) {
  const router = useRouter()
  const [breadcrumbs, setBreadcrumbs] = useState<any>(null)

  useEffect(() => {
    if (router) {
      const linkPath = router.asPath.split('/')
      linkPath.shift()

      const pathArray = linkPath.map((path, i) => {
        return {
          breadcrumb: path.split("?")[0],
          href: '/' + linkPath.slice(0, i + 1).join('/'),
        }
      })

      setBreadcrumbs(pathArray)
    }
  }, [router])

  // if (!breadcrumbs) {
  //   return null
  // }

  return (
    <>
      <Head>
        <title>{props.title}</title>
        <meta name="title" content={props.title} />
        <meta name="description" content={props.description} />
        <meta name="keywords" content={props.keywords} />

        <meta property="og:type" content="website" />
        {
          props.links && (
            <meta
              property="og:url"
              content={`https://centraldagrama.com${props.links}`}
            />
          )
        }
        <meta property="og:title" content={props.title} />
        <meta property="og:description" content={props.description} />
        <meta
          property="og:image"
          content={`${props.cover
            ? props.cover
            : 'https://metatags.io/assets/meta-tags-16a33a6a8531e519cc0936fbba0ad904e52d35f34a46c97a2c9f6f7dd7d336f2.png'
            }`}
        />

        <meta property="twitter:card" content="summary_large_image" />
        {
          props.links && (
            <meta
              property="twitter:url"
              content={`https://centraldagrama.com/${props.links}`}
            />
          )
        }
        <meta property="twitter:title" content={props.title} />
        <meta property="twitter:description" content={props.description} />
        <meta
          property="twitter:image"
          content={`${props.cover
            ? props.cover
            : 'https://metatags.io/assets/meta-tags-16a33a6a8531e519cc0936fbba0ad904e52d35f34a46c97a2c9f6f7dd7d336f2.png'
            }`}
        />
      </Head>
      <S.Top>
        <S.Background>
          <Container>
            <Navbar />
          </Container>
          <S.WrapBox>
            <S.Box>

              <S.Category
                css={
                  props.categorySize
                    ? { ...{ fontSize: `${props.categorySize} !important` } }
                    : {}
                }
              >
                {props.category}
              </S.Category>

              <Breadcrumb separator={<ChevronRightIcon color="gray.600" />}>
                <BreadcrumbItem>
                  <Link href={'/'} passHref>
                    <BreadcrumbLink>Início</BreadcrumbLink>
                  </Link>
                </BreadcrumbItem>
                {breadcrumbs?.map((breadcrumb: any, i: any) => {
                  return (
                    <BreadcrumbItem key={i}>
                      <Link href={breadcrumb.href} passHref>
                        <BreadcrumbLink>
                          {convertBreadcrumb(breadcrumb.breadcrumb)}
                        </BreadcrumbLink>
                      </Link>
                    </BreadcrumbItem>
                  )
                })}
              </Breadcrumb>



              {
                props.subtitle && (
                  <S.ScientifcName>
                    {props.subtitle}
                  </S.ScientifcName>
                )
              }
              {
                props.h2 && (
                  <S.CategorySmall>
                    {props.h2}
                  </S.CategorySmall>
                )
              }
            </S.Box>
          </S.WrapBox>
        </S.Background>
      </S.Top>
      <S.Main>{children}</S.Main>
      <Footer />
    </>
  )
}
